import digitalData from 'digital-data';

export const salientPoints = () => {
  window.LIFE_CYCLE_EVENT_BUS.on('salient-points.icon-test', ({ output = {} }) => {
    const { salientType } = output;
    digitalData.page = digitalData.page || {};
    digitalData.page.pageInfo = digitalData.page.pageInfo || {};
    digitalData.page.pageInfo.kpfTest = salientType;
  });
  window.LIFE_CYCLE_EVENT_BUS.on('salient-points.accordion-open', () => {
    digitalData.event = digitalData.event || [];
    digitalData.event.push({
      category: {
        primaryCategory: 'interaction'
      },
      eventInfo: {
        eventName: 'pip sub-content'
      },
      subContent: {
        component: 'see more',
        section: `salient ${salientType}`,
        target: 'product details"'
      },
    });
  });
};
